export default __webpack_public_path__ + "static/spa-header-bg-5a76775e4d240514d2bfe2be00603283.jpg";